<template>
  <div :aria-multiselectable="mode == 'multi'" role="tablist" :id="id">
    <div class="accordion-filter">
      <slot name="buttons">
        <AccordionButton
          v-if="buttons"
          v-for="button in buttons"
          v-bind="button"
          :collapsed="!model.includes(button.group)"
          :parent="id"
          @click="(e) => toggleGroup(e.target.parentElement, button.group)"
        />
      </slot>
    </div>
    <slot name="content" />
  </div>
</template>
<script setup lang="ts">
  import { HTMLAttributes, PropType } from 'vue';
  import AccordionButton from './AccordionButton.vue';
  interface AccordionButtonProps extends HTMLAttributes {
    group: string;
    desktopLabel: string;
    mobileLabel: string;
  }
  type AccordionMode = 'multi' | 'single';
  const model = defineModel<Array<string>>({ default: [] });
  const emit = defineEmits(['update:modelValue']);

  const toggleGroup = (e: Element, group: string) => {
    const allButtons = [...document.querySelectorAll('span.accordion-item button')] as HTMLButtonElement[];
    console.log('toggleGroup:', group, model.value, e, allButtons);
    //toggle of
    if (model.value.includes(group)) {
      model.value = model.value.filter((g) => g !== group);
    } else {
      //toggle on

      //if single
      if (props.mode === 'single') {
        allButtons.forEach((button) => {
          if (button != e && !button.classList.contains('collapsed')) {
            button.click();
          }
        });

        model.value = [group];
      } else {
        //if multi
        model.value.push(group);
      }
    }
  };

  const props = defineProps({
    buttons: {
      type: Array<AccordionButtonProps>,
      required: false,
    },
    mode: {
      type: String as PropType<AccordionMode>,
      default: 'single',
    },
    id: {
      type: String,
      required: false,
    },
  });
</script>
